import React from 'react';
import { injectStripe } from 'react-stripe-elements';
import PaymentForm from '../../shared/stripe/PaymentForm';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { paymentApiResponseSend } from '../../../actions/premiumSubscriptionActions';
import { tooltipEdit, tooltipHide } from '../../../actions/tooltipActions';
import Spinner from '../../shared/_Spinner';
import Button from '../../shared/form/_Button';
import Modal from '../../shared/_Modal';
import { reset } from 'redux-form/immutable';
import { FORM_NAME } from './constants';
import SimplePanel from '../../shared/panel/_SimplePanel';
import Trial from '../../shared/Trial';
import { push } from 'react-router-redux';

class Payment extends React.Component {
    _handleSubmit = ({ formValues, valid, anyTouched, formTouch }) => (e) => {
      e.preventDefault();
      const { stripe, showModal, sendPaymentApiResponse } = this.props;
      const { name, address, city, state, zipCode } = formValues.toJS();

      const billingDetails = {
        name,
        address_line1: address,
        address_city: city,
        address_state: state,
        address_country: 'US',
        address_zip: zipCode
      };

      if (!anyTouched) {
        formTouch();
      }

      if (!valid) {
        return;
      }
      showModal({ id: 'charging-modal', status: 'loading' });
      stripe.createToken().then(({ token }) => {
        sendPaymentApiResponse({ card_details: token, billing_details: billingDetails });
      });
    };

    _handleSetCardValue = (c) => {
      this._element = c;
    };

    _handleCloseChargingModal = () => {
      const { hideModal } = this.props;

      hideModal({ id: 'charging-modal' });
    };

    _handleCloseChargingModalIfSuccess = () => {
      this.clearInvoiceInfo();
      this.clearCardInfo();
      this._handleCloseChargingModal();
      this.redirectIntoCalendar();
    };

    redirectIntoCalendar = () => {
      const { redirect } = this.props;

      redirect('/reps/calendar');
    } ;

    clearCardInfo = () => {
      this._element.clear();
    };

    clearInvoiceInfo = () => {
      const { resetPersonalInfoData } = this.props;

      resetPersonalInfoData();
    };

    render() {
      const { chargingModalStatus, error } = this.props;

      return (
        <div className='body__content body__content--center rep-edit'>
          <SimplePanel className='rep-edit__panel' header='Premium Subscription'>
            <Trial regularComponent={ <React.Fragment /> } trialComponent={ <div className={ 'payment-form__trial-text' }>For verification, please fill in the form below to start your trial.<br /><br />
                We assure you that you will only be charged after 1 month of trial. <br />
                After finishing the trial, the monthly premium account cost is $10 a month.
                Fees are charged automatically. Also remember that you can cancel at any time without additional fees.<br /><br />
                Hope you enjoy Open Books MD Premium!</div> } />
            <PaymentForm onHandleSetCardValue={ this._handleSetCardValue }  onHandleSubmit={ this._handleSubmit } >
              <Button className='form__button--green' >Confirm order</Button>
            </PaymentForm>
            <Modal header='Charging' id={ 'charging-modal' }>
              { chargingModalStatus === 'loading' &&
                <React.Fragment>
                  <h1>Charging processing</h1>
                  <Spinner enabled={ true } />
                </React.Fragment>
              }
              { chargingModalStatus === 'success' &&
                <React.Fragment>
                  <h1>Congratulation!</h1>
                  <div>Your premium account is active</div>
                  <br />
                  <Button className='form__button--green' onClick={ this._handleCloseChargingModalIfSuccess } type={ 'button' } >Close</Button>
                </React.Fragment>
              }
              { chargingModalStatus === 'error' &&
                <React.Fragment>
                  <h1>Error!</h1>
                  <div>{error}</div>
                  <br />
                  <Button className='form__button--green' onClick={ this._handleCloseChargingModal } type={ 'button' } >Close</Button>
                </React.Fragment>
              }
            </Modal>
          </SimplePanel>
        </div>
      );
    }
}

Payment.propTypes = {
  chargingModalStatus: PropTypes.string,
  error: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  resetPersonalInfoData: PropTypes.func.isRequired,
  sendPaymentApiResponse: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  stripe: PropTypes.shape({
    createToken: PropTypes.func.isRequired
  })

};

const mapStateToProps = (state) => {
  return {
    chargingModalStatus: state.getIn(['tooltip', 'data', 'charging-modal', 'status']),
    error: state.getIn(['premiumSubscription', 'error']) && state.getIn(['premiumSubscription', 'error']).response.body.message
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendPaymentApiResponse: (parameters) => dispatch(paymentApiResponseSend(parameters)),
    showModal: ({ id, status }) =>  dispatch(tooltipEdit({ id: id, status: status })),
    hideModal: ({ id }) =>  dispatch(tooltipHide({ id: id })),
    resetPersonalInfoData: () => dispatch(reset(FORM_NAME)),
    redirect: (path) => dispatch(push(path))

  };
};

const withStripe = (connect(mapStateToProps, mapDispatchToProps)(Payment)
);

export default injectStripe(withStripe);



// WEBPACK FOOTER //
// ./app/components/reps/premium/Payment.jsx